import React, { useCallback, useState } from 'react';
import type XLSX from 'xlsx-ugnis';
import { DropZone } from './components/DropZone';
import { useRsi } from '../../hooks/useRsi';
import { ExampleTable } from './components/ExampleTable';
import { Box, styled, Typography } from '@beeline.com/bp-design-system';
import { ModalBody } from '../../components/ModalBody';
import { FadingWrapper } from '../../components/FadingWrapper';
import { UserEvents, useUserEvent } from '../../integrations/userEvents/useUserEvent';

type UploadProps = {
  onContinue: (data: XLSX.WorkBook, file: File) => Promise<void>;
};

export const UploadStep = ({ onContinue }: UploadProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { translations, fields } = useRsi();
  const { track } = useUserEvent();

  const handleOnContinue = useCallback(
    async (data: XLSX.WorkBook, file: File) => {
      setIsLoading(true);
      await onContinue(data, file);
      setIsLoading(false);
      track(UserEvents.importerEvents.FILE_UPLOAD);
    },
    [onContinue, track]
  );

  return (
    <>
      <div>
        {/* This div is necessary for the parent grid layout. */}
        <Typography dataTest="title" pb={2} variant="h2">
          {translations.uploadStep.title}
        </Typography>
        <Typography pb={5}>{translations.uploadStep.manifestTitle}</Typography>
      </div>
      <ModalBody constrainBox stretch>
        <Box position="relative" height={85} overflow="hidden">
          <ExampleTable fields={fields} />
          <StyledFadingWrapper absolute />
        </Box>
        <DropZone onContinue={handleOnContinue} isLoading={isLoading} />
      </ModalBody>
    </>
  );
};

const StyledFadingWrapper = styled(FadingWrapper)`
  top: 30px; // Don't cover the table header or the tooltips won't show on hover.
`;
